import React, {Component} from "react"
import PropTypes from "prop-types"
import Signature from "./Signature"
import {Dimmer, Form, Input} from "semantic-ui-react"
import {withTranslation} from 'react-i18next'

class SignatureDialog extends Component {

  static propTypes = {
    onFail:           PropTypes.func,
    onSubmit:         PropTypes.func,
    onSuccess:        PropTypes.func,
    setup:            PropTypes.func,
    showNameInput:    PropTypes.bool,
    signatureOptions: PropTypes.object
  }

  static  defaultProps = {
    showNameInput: false
  }

  constructor({ name = "", signatureOptions }) {
    super()
    this.state = {
      name
    }

    this.signatureOptions = {
      minWidth:        1,
      maxWidth:        3,
      penColor:        "rgb(10,10,10)",
      encoderOptions:  "image/jpeg",
      backgroundColor: "rgb(255,255,255)",
    }
    Object.assign( this.signatureOptions, signatureOptions )
  }

  submit = () => {
    const signature = this.refs.signature
    if ( signature.isEmpty() ) {
      this.props.onFail( "No signature entered" )
    }
    else {
      const dataUrl = signature.publish()
      this.props.onSuccess( dataUrl )
    }
  }

  handleForm = (e, { value }) => {
    this.setState( { name: value } )
    this.signaturePad.name = value
    // if (this.hasName()) {
    //   this.signaturePad.on()
    // }
  }

  hasName = () => {
    let { name } = this.state
    return !!(name && name.length >= 3)
  }

  handleSubmit = () => {
    console.log( `handle submit` )
    this.props.onSubmit( this.signaturePad, name )
  }

  setup = ({ signaturePad }) => {
    this.props.setup && this.props.setup( { signaturePad } )
    this.signaturePad = signaturePad
  }

  render() {
    let signatureOptions            = this.signatureOptions
    let { children, showNameInput } = this.props
    let { name }                    = this.state
    let hasName                     = this.hasName()
    const {t} = this.props;

    return (
      <div className="SignatureDialog">
        {/*{ !hasName ? <Label style={{ marginLeft: "18px" }} color='yellow' ribbon>Name hinzufügen</Label> : null}*/}
        { !showNameInput ? null : <Form.Field className="pb3">
          <Input
            value={name}
            fluid
            label="Name"
            placeholder={t("general.names")}
            onChange={this.handleForm}
          />
        </Form.Field> }

        <Dimmer.Dimmable dimmed={!hasName}>
          <Dimmer active={!hasName}>
            {t("general.namesFirst")}
          </Dimmer>
          {this.props.onSubmit ? <Signature
            disabled={hasName}
            ref="signature"
            setup={this.setup}
            onSubmit={this.handleSubmit}
            options={signatureOptions}
          /> : <Signature
            disabled={hasName}
            ref="signature"
            setup={this.setup}
            options={signatureOptions}
          />}
        </Dimmer.Dimmable>

        <div onClick={() => {
          this.props.onSubmit( this.signaturePad, name )
        }}>{children}</div>
      </div>
    )
  }
}

export default withTranslation()(SignatureDialog)



// WEBPACK FOOTER //
// ./src/pages/components/SignatureDialog/SignatureDialog.js